module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "author"
  }, [_vm._v("17")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_c('span', [_vm._v("Ich warte")]), _vm._v(" nur auf die\nLiebe, um"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nendlich mich in seine Hände aufzugeben."), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nDeshalb bin ich so spät, und deshalb bin"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nich schuldig so vieler Lücken.")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Sie kommen mit ihren Gesetzen und"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nRegeln, um mich zu binden, doch ich"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nentschlüpfe ihnen immer wieder, denn"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nich warte nur auf die Liebe, um endlich"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nmich in seine Hände aufzugeben.")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Die Leute tadeln mich, nennen mich"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nunbedacht, ich zweifle nicht, sie haben"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nRecht zum Tadel.")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Der Markttag ist vorüber, alle Arbeit"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nist getan für die Geschäftigen. Die da kamen"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\numsonst mich zu rufen, gingen voll"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nZorn. Ich aber warte nur auf die Liebe,"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\num endlich mich in seine Hände aufzugeben. "), _c('a', {
    attrs: {
      "id": "page22",
      "title": "cal/wedi"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a2250ec8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0018.vue
// module id = 108
// module chunks = 0